import React from 'react';
import CustomForm from "../form";
import './contact-block.scss'
import {useTranslation} from "react-i18next";

function ContactBlock() {
    const { t } = useTranslation()
    return (
        <div id="contact" className="contact-block">
            <div className="contact-block__wrapper">
                <div className="contact-block__column" data-aos="fade-right">
                    <h4 className="contact-block__title title">{t('contact_block.title')}</h4>
                    <div className="contact-block__description">{t('contact_block.description')}</div>
                    <div className="line">
                        <div className="circle"></div>
                    </div>
                </div>

                <div className="contact-block__column contact-block__column--form" data-aos="fade-left">
                    <CustomForm/>
                </div>
            </div>

        </div>
    );
}

export default ContactBlock;